import { useLocale } from '../i18n/LocaleContext';
import React from 'react';
import Hero from '../components/Hero';
import Pricing from '../components/Pricing';
import Features from '../components/Features';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';
import SEO from '../components/SEO';
import Video from '../components/Video';
import ClinicalWorkflow from '../components/ClinicalWorkflow';
import HomeFAQs from '../components/HomeFAQs';
import { homeStructuredData } from '../content/home';

const HomePage = () => {
  const { t, locale, path } = useLocale();
  return (
    <>
      <SEO
        title={t("seo.homeTitle")}
        description={t("seo.home")}
        canonicalPath="/"
        structuredData={homeStructuredData(t, locale, `https://www.noteician.com${path('/')}`)}
      />
      <Hero />
      <ClinicalWorkflow />
      <Pricing headingLevel="h2" />
      <Testimonials />
      <Video />
      <Features />
      <HomeFAQs />
      <CTA />
    </>
  );
};

export default HomePage;
